import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Container: ComponentStyleConfig = {
  baseStyle: {
    maxW: '110em',
  },
};
